import PropTypes from 'prop-types';
import SidebarCollapseButton from '../layout/SidebarCollapseButton';
import { StyledAppLogo } from './index.styled';

/** Full LEAP lockup — TM + “A SOLUTIONS COMPANY” (suite brand pack) */
const LEAP_LOGO_RED = '/assets/images/leap-logo-red.png';

/**
 * Header brand row — RFID PanelLeft collapse + LEAP company logo.
 */
const BrandLogo = () => (
  <div className="leap-header-brand">
    <SidebarCollapseButton variant="header" />
    <StyledAppLogo>
      <img src={LEAP_LOGO_RED} alt="LEAP — A Solutions Company" draggable={false} />
    </StyledAppLogo>
  </div>
);

export default BrandLogo;

BrandLogo.propTypes = {
  hasSidebarColor: PropTypes.bool,
};
